export default {
  methods: {
    unexpectedError (defaultMessage = this.$t('general.unexpected_error')) {
      let errorMsg = ''
      errorMsg = defaultMessage
      this.$toastr.e(errorMsg)
    }
  }
}
